export const JOB_MODE = {
  NORMAL: 'normal',
  FLEX: 'flex',
  STANDBY: 'standby',
  BACKUP: 'backup',
  DISPO: 'dispo',
} as const;

export type JobMode = (typeof JOB_MODE)[keyof typeof JOB_MODE];

const JOB_MODE_LABELS: Record<JobMode, string> = {
  [JOB_MODE.NORMAL]: 'Normal',
  [JOB_MODE.FLEX]: 'Flex-date',
  [JOB_MODE.STANDBY]: 'Standby',
  [JOB_MODE.BACKUP]: 'Backup',
  [JOB_MODE.DISPO]: 'Dispo',
};

export function isFlexJobMode(mode?: JobMode): boolean {
  return (
    mode === JOB_MODE.FLEX ||
    mode === JOB_MODE.STANDBY ||
    mode === JOB_MODE.DISPO
  );
}

export function getJobModeLabel(mode: JobMode): string {
  return JOB_MODE_LABELS[mode];
}
